export default __webpack_public_path__ + "static/media/phoneVideo_bg.a1779f68.jpg";